import api from "@/lib/api";

/**
 * Check-ID BNT — POST /api/identity/check (lógica en backend, Web + Desktop).
 */
export async function checkIdentity({
  rfc = "",
  curp = "",
  nss = "",
  client_id = "",
  source_module = "manual",
} = {}) {
  const { data } = await api.post("/identity/check", {
    rfc: (rfc || "").trim().toUpperCase(),
    curp: (curp || "").trim().toUpperCase(),
    nss: String(nss || "").replace(/\D/g, ""),
    client_id: (client_id || "").trim(),
    source_module: (source_module || "manual").trim() || "manual",
  });
  return data;
}
